import { render, staticRenderFns } from "./AuthReset.vue?vue&type=template&id=14ec13c6&"
import script from "./AuthReset.vue?vue&type=script&lang=js&"
export * from "./AuthReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ec13c6')) {
      api.createRecord('14ec13c6', component.options)
    } else {
      api.reload('14ec13c6', component.options)
    }
    module.hot.accept("./AuthReset.vue?vue&type=template&id=14ec13c6&", function () {
      api.rerender('14ec13c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth/src/features/auth/screens/AuthReset.vue"
export default component.exports